
const userReducer = (state = { token: null, loading: false, fetchedInLogin: false }, action) => {
  switch (action.type) {
    case 'SET_USER':
      return {
        ...state,
        user: action.user
      }
    case 'SET_TOKEN':
      return {
        ...state,
        token: action.token
      }
    case 'LOG_USER':
      return {
        ...state,
        user: action.login.user,
        token: action.login.token
      }
    case 'SET_USER_ATTRIBUTE':
      return {
        ...state,
        user: {
          ...state.user,
          ...action.attribute
        }
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.loading
      }
    case 'SET_FETCHED_IN_LOGIN':
      return {
        ...state,
        fetchedInLogin: action.fetchedInLogin
      }
    default:
      return state
  }
}

export default userReducer



// WEBPACK FOOTER //
// ./src/redux/reducers/userReducer.js